module.exports = __webpack_public_path__ + "img/broadcast-tiao-icon2.e8cd5cf9.png";